module.exports = __webpack_public_path__ + "img/banner文字@2x.62c5eee7.png";